import Logo, { LOGO_COLORS } from './Logo';
export { LOGO_COLORS };
export default Logo;
